import { render, staticRenderFns } from "./pillsModule.vue?vue&type=template&id=058cbe55&scoped=true"
import script from "./pillsModule.vue?vue&type=script&lang=js"
export * from "./pillsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058cbe55",
  null
  
)

export default component.exports